angular
    .module('annexaApp')
    .component('annexaBoxObjectRegisterSettlement',{
        templateUrl: './components/reg/annexa-box-object-register-settlement/annexa-box-object-register-settlement.html',
        controller:['$rootScope', '$filter', 'Language', 'GlobalDataFactory', 'HelperService', 'CommonService', '$scope', '$state', 'NotificationFactory', 'AnnexaFormlyFactory', 'TerritoryFactory', 'SecFactory', 'AnnexaPermissionsFactory', '$state', 'globalModals', 'RegFactory', 'DialogsFactory', 'ThirdFactory', '$http', 'RestService', '$q', 
		function($rootScope, $filter, Language, GlobalDataFactory, HelperService, CommonService, $scope, $state, NotificationFactory, AnnexaFormlyFactory, TerritoryFactory, SecFactory, AnnexaPermissionsFactory, $state, globalModals, RegFactory, DialogsFactory, ThirdFactory, $http, RestService, $q) {
            var vm = this;
			vm.languageColumn = undefined;
			vm.settlementBox = {};
			vm.settlementsActive = false;
    		
			var generateSettlementBox= function(){
				if(!vm.settlementTableDefinition){
					vm.settlementTableDefinition = {};
				}
				var addSettlement = function() {
					if(vm.registerEntryId){
						var promises = [];
			        	promises.push(RestService.findAll('TaxBlock'));
			        	promises.push(RegFactory.getRelatedThirds(vm.registerEntryId)); 
						$q.all(promises).then(function(data) {
		 	            	 var taxBlocks = JSOG.decode(data[0].data);
			            	 var thirdsAux = JSOG.decode(data[1]);
			            	 var thirds = [];
			            	 if(thirdsAux && thirdsAux.length > 0){
			            		 _.forEach(thirdsAux, function(ta){
			            			thirds.push({id:((ta.id)?ta.id:undefined), thirdId:((ta.third && ta.third.id)?ta.third.id:undefined), name:((ta.third.completeName)?ta.third.completeName:"")}); 
			            		 });
			            	 }
			             	 var modal = angular.copy(globalModals.addDossierSettlement);
			                 modal.annexaFormly.model = {};
			                 modal.annexaFormly.model.modal_body = {};
			                 modal.annexaFormly.options = {};
			                 modal.annexaFormly.options.formState = { readOnly: false};
			                 var submitFunction = function() {
			                      var self = this;
			                      self.alerts.length = 0;
			                      var model = ((this.annexaFormly && this.annexaFormly.model && this.annexaFormly.model.modal_body)?this.annexaFormly.model.modal_body:{});
			                      var modalFields = ((this.annexaFormly && this.annexaFormly.fields && this.annexaFormly.fields.length > 0 && this.annexaFormly.fields[0].fieldGroup)?this.annexaFormly.fields[0].fieldGroup:undefined); 
			                      var principal = undefined;
			                      var representant = undefined;
			                      var taxBlock = undefined;
			                      if(thirds && thirds.length > 0){
			                    	  principal = $linq(thirds).firstOrDefault(undefined, "x => x.id == "+((model.principal)?model.principal:-1));
			                    	  representant = $linq(thirds).firstOrDefault(undefined, "x => x.id == "+((model.representant)?model.representant:-1));
			                      }
			                      if(model.taxBlockFromBBDD && model.taxBlockFromBBDD.id){
			                    	  taxBlock = model.taxBlockFromBBDD;
			                      }
			                      var send = {
			                    	registerEntry: {id:vm.registerEntryId},
			                    	settlement:{
			                    		settlementType: ((model.settlementType)?model.settlementType:"ASSESSMENT"),
			                    		taxBlock: ((model.taxBlock)?{id:model.taxBlock}:undefined),
		                		    	principal: ((principal && principal.thirdId)?{id:principal.thirdId}:undefined),
		                		    	representant: ((representant && representant.thirdId)?{id:representant.thirdId}:undefined),
		                		    	subject: ((model.subject)?model.subject:""),
		                		    	year: ((model.year)?model.year:new Date().getFullYear()),
		                		    	period: ((model.period)?model.period:1),
	            						limitationPeriod:((model.limitationPeriod)?model.limitationPeriod:undefined)
			                    	}
		                		  };
			                      if(send.settlement.taxBlock && send.settlement.taxBlock.id && send.settlement.principal && send.settlement.principal.id && send.settlement.subject && send.settlement.year && send.settlement.settlementType && send.settlement.period){
		                			  $http({
		                                 url: './api/reg/register_entry_settlement',
		                                 method: 'POST',
		                                 data: send
		                              }).then(function (data, status, headers) {
		                            	  	if(data && data.data && data.data.settlement && data.data.settlement.externalId){
		                              		  $rootScope.$broadcast('annexaBoxRegisterSettlementReloadTable', {});
		                              		  var url = angular.copy($rootScope.app.configuration.settlement_properties_active.urlBase);
		                              		  var credentials = angular.copy($rootScope.app.configuration.settlement_properties_active.credentials);
		                              		  var authentication = angular.copy($rootScope.app.configuration.settlement_properties_active.authentication);
		                              		  credentials.id = $rootScope.LoggedUser.id+"";
		                              		  credentials.token = $rootScope.LoggedUser.token;
		                              		  credentials = JSON.stringify(credentials);
		                              		  url = url.replace('--settlementId--',data.data.settlement.externalId);
		                              		  window.open(url+authentication+encodeURIComponent(credentials), '_blank');
		                              		  self.close();
		                            	  	}else{
		                            	  		self.alerts.push({msg:  $filter('translate')('global.taxBlock.serverError')});
		                            	  	}
		                              }).catch(function (error) {
		                            	  if(error && error.data && error.data.message === 'Required fields error'){
		        	                    	  this.alerts.push({ msg: $filter('translate')('global.taxBlock.requiredError') });
		                            	  }else if(error && error.data && error.data.message === 'Register not passed'){
		        	                    	  this.alerts.push({ msg: $filter('translate')('global.taxBlock.registerRequiredError') });
		                            	  }else{
		                            		  self.alerts.push({msg:  $filter('translate')('global.taxBlock.serverError')});
		                            	  }
		                              });
			                      }else{
			                    	  this.alerts.push({ msg: $filter('translate')('global.taxBlock.requiredError') });
			                      }
			                 }
			                 if(taxBlocks && taxBlocks.length > 0){
			                	 var taxBlockField = $linq(modal.annexaFormly.fields[0].fieldGroup).firstOrDefault(undefined, "x => x.key == 'taxBlock'");
			                	 if(taxBlockField && taxBlockField.templateOptions){
			                		 taxBlockField.templateOptions.options = taxBlocks;
			                	 }
			                 }
			                 if(thirds && thirds.length > 0){
			                	 var principalField = $linq(modal.annexaFormly.fields[0].fieldGroup).firstOrDefault(undefined, "x => x.key == 'principal'");
			                	 if(principalField && principalField.templateOptions){
			                		 principalField.templateOptions.options = thirds;
			                	 }
			                	 var representantField = $linq(modal.annexaFormly.fields[0].fieldGroup).firstOrDefault(undefined, "x => x.key == 'representant'");
			                	 if(representantField && representantField.templateOptions){
			                		 representantField.templateOptions.options = thirds;
			                	 }
			                 }
			             	 
			                 AnnexaFormlyFactory.showModal('addSettlementsModal', modal, submitFunction, false, undefined);
			            }).catch(function(error) {
			            });
		        	}
					
				}
				var newSettlementCreateMassiveDocuments = function() {
					var newSettlementCreateMassiveDocumentModal = function(settlements){
						var modal = angular.copy(globalModals.createDossierSettlementDocument);
		                modal.annexaFormly.model = {};
		                modal.annexaFormly.model.modal_body = {showSettlements:true};
		                modal.annexaFormly.options = {};
		                modal.annexaFormly.options.formState = { readOnly: false};
		                
		                var settlementsField = $linq(modal.annexaFormly.fields[0].fieldGroup).firstOrDefault(undefined, "x => x.key == 'settlements'");
		                if(settlementsField){
		                	_.forEach(settlements, function(set){
		                		set.label = set.settlement.settlementNumber + " "+set.settlement.subject;
		                		modal.annexaFormly.model.modal_body['settlements_'+set.id] = true;
		                	}); 
		                	settlementsField.templateOptions.options = settlements;
		                }
		                var submitFunction = function() {
		                      var self = this;
		                      self.alerts.length = 0;
		                      var model = ((this.annexaFormly && this.annexaFormly.model && this.annexaFormly.model.modal_body)?this.annexaFormly.model.modal_body:{});
		                      var send = {
		                        paymentDeadLine: model.paymentDeadLine
	                  		  };
		                      var settlementIds = [];
		                      _.forEach(settlements, function(set){
			                  	  if(modal.annexaFormly.model.modal_body['settlements_'+set.id]){
			                  		  settlementIds.push(set.settlement.id);
			                  	  };
			                  }); 
		                      $http({
		                           	url: './api/tram/dossier_settlement/settlements_document/'+CommonService.getParameterList(settlementIds),
		                           	method: 'PUT',
		                           	data: send
		                      }).then(function (data, status, headers) {
		                    	  	if(data && data.data){
		                    	  		var ok = "";
		                    	  		var ko = "";
		                    	  		var keys = Object.keys(data.data);
		                    	  		_.forEach(settlements, function(set){
		                    	  			if(settlementIds && _.contains(settlementIds,set.settlement.id)){
			    		                		if(data.data[set.settlement.id]){
			    		                			ok = ok+((ok === "")?"<br/><br/>":"<br/>")+'&nbsp;&nbsp;&nbsp;&nbsp;'+set.settlement.settlementNumber + " "+set.settlement.subject;
			    		                		}else{
			    		                			ko = ko+((ko === "")?"<br/><br/>":"<br/>")+'&nbsp;&nbsp;&nbsp;&nbsp;'+set.settlement.settlementNumber + " "+set.settlement.subject;
			    		                		}
		                    	  			}
		    		                	})
		                    	  	}
		                    	  	
		                    	  	var msgOK = $filter('translate')('global.taxBlock.generatedDocumentsOk')+ok;
		                    	  	var msgKO = '<span class="text-danger">'+$filter('translate')('global.taxBlock.generatedDocumentskO')+ko+'</span>';
		                    	  	var msg = ((ok === "" )?"":msgOK+"<br/><br/>")+ ((ko === "" )?"":msgKO+"<br/><br/>")
		                    	  	if(ok !== ""){
		                    	  		DialogsFactory.notify(msg);
		                    	  	}else{
		                    	  		DialogsFactory.error(msg, $filter('translate')('DIALOGS_ERROR_MSG'));
		                    	  	}
		                        	self.close();
		                      }).catch(function (error) {
		                    	  	self.alerts.push({msg:  $filter('translate')('global.taxBlock.createDocumentServerError')});
		                      });
		                 }
		                 AnnexaFormlyFactory.showModal('createSettlementDocumentModal', modal, submitFunction, false, undefined);
					}
					$http({
                       	url: './api/reg/register_entry_settlement/register_entry_settlements/'+vm.registerEntryId,
                       	method: 'GET'
					}).then(function (data, status, headers) {
						var settlements = JSOG.decode(data.data);
						newSettlementCreateMassiveDocumentModal(settlements);
				    }).catch(function (error) {
				    	newSettlementCreateMassiveDocumentModal([])
                    });
				}
				var principalRender = function (data, type, full, meta) {
					var content = '';
					if(data && data.identificationDocument){
						content = "<label title=\""+data.completeName+"\">"+data.identificationDocument+"<label>";
					}
					return content;
				}
				vm.viewSettlement = function(setId){
					var url = angular.copy($rootScope.app.configuration.settlement_properties_active.urlBase);
					var credentials = angular.copy($rootScope.app.configuration.settlement_properties_active.credentials);
					var authentication = angular.copy($rootScope.app.configuration.settlement_properties_active.authentication);
					credentials.id = $rootScope.LoggedUser.id+"";
					credentials.token = $rootScope.LoggedUser.token;
					credentials = JSON.stringify(credentials);
					url = url.replace('--settlementId--',setId)
					window.open(url+authentication+encodeURIComponent(credentials), '_blank');
				}
				vm.newSettlementCreateDocument = function(setId) {
					var modal = angular.copy(globalModals.createDossierSettlementDocument);
	                modal.annexaFormly.model = {};
	                modal.annexaFormly.model.modal_body = {showSettlements:false};
	                modal.annexaFormly.options = {};
	                modal.annexaFormly.options.formState = { readOnly: false};
	                var submitFunction = function() {
	                      var self = this;
	                      self.alerts.length = 0;
	                      var model = ((this.annexaFormly && this.annexaFormly.model && this.annexaFormly.model.modal_body)?this.annexaFormly.model.modal_body:{});
	                      var send = {
	                        paymentDeadLine: model.paymentDeadLine
                  		  };
	                      $http({
	                           	url: './api/tram/dossier_settlement/settlement_document/'+setId,
	                           	method: 'PUT',
	                           	data: send
	                      }).then(function (data, status, headers) {
	                    	  	DialogsFactory.notify($filter('translate')('global.taxBlock.generatedDocumentOk'));
	                        	self.close();
	                      }).catch(function (error) {
	                    	  	self.alerts.push({msg:  $filter('translate')('global.taxBlock.createDocumentServerError')});
	                      });
	                 }
	                 AnnexaFormlyFactory.showModal('createSettlementDocumentModal', modal, submitFunction, false, undefined);
				}
				var actionsRightAccessRender = function (data, type, full, meta) {
					var content = '';
					if(vm.isEdit && (AnnexaPermissionsFactory.havePermission(['open_dossier_settlements']) || AnnexaPermissionsFactory.havePermission(['add_dossier_settlements']))){
						content += '<div class="btn-group dropdown flexbuttons">';
					    content += '    <a class="btn primary" tabindex="0" href=""  ng-click="$ctrl.viewSettlement(' + full.settlement.externalId + ')">';
						content += '        <i class="fa fa-eye" aria-hidden="true"></i>'+$filter('translate')('global.literals.see');
						content += '    </a>';
						content += '    <div class="btn-group" >';
                        content += '    	<button type="button" class="btn primary dropdown-toggle p-x-sm" data-toggle="dropdown" title="'+$filter('translate')('global.literals.showOptions')+'">';
						content += '            <span class="sr-only">'+$filter('translate')('global.literals.showOptions')+'</span>';
						content += '        </button>';
						content += '        <div class="dropdown-menu primary pull-right">';
						content += '        	<button type="button" class="dropdown-item" ng-click="$ctrl.newSettlementCreateDocument(' + full.settlement.id + ')">';
						content += '                <span>'+$filter('translate')('global.taxBlock.generateDocument')+'</span>';
						content += '            </button>';
        				content += '		</div>';
                        content += '    </div>';
                        content += '</div>';
					}
	                return content;
	            }
				var actionsTitle = function () {
    	            return '<div class="column-actions">' + $filter('translate')('global.literals.actions') + '</div>';
	            }
				var statusRender = function (data, type, full, meta) {
					var content = '';
					if($rootScope && $rootScope.app && $rootScope.app.configuration && $rootScope.app.configuration.settlement_properties_active && $rootScope.app.configuration.settlement_properties_active.active){
	        			var legend = $rootScope.app.configuration.settlement_properties_active.settlementStatus;
	            		if(legend && legend.length > 0){
	            			_.forEach(legend, function(l){
	            				if(l.id === data && l.icon && l.style){
	            					content = '<div class="text-center"><span class="fa-stack"><i class="fa fa-'+l.icon+' '+l.style+' text-lg fa-stack-1x" '+((l[vm.languageColumn])?'title="'+l[vm.languageColumn]+'">':'>')+'</i></span></div>';
	            				}else if(l.id === data && l[vm.languageColumn]){
	            					content = l[vm.languageColumn];
	            				}
	            			});
	            		}
	            		
	            	}
					if(content === ''){
						content = data;
					}
					return content;
				}
				
				var amountRender = function (data, type, full, meta) {
					var content = '';
					if(data !== null && data !== undefined){
	        			content = new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(data)
	            	}
					return content;
				}
				
				var columnsSettlement = [
					{ id: 'settlement.settlementNumber', width: '250px', title: $filter('translate')('global.literals.code')},
					{ id: 'settlement.taxBlock.' + vm.languageColumn, title: $filter('translate')('global.taxBlock.title') },
					{ id: 'settlement.principal', width: '300px', title: $filter('translate')('global.taxBlock.third'), render: principalRender },
					{ id: 'settlement.subject', width: '3000px', title: $filter('translate')('global.literals.description')},
					{ id: 'settlement.status', width: '250px', title: $filter('translate')('global.literals.state'), render: statusRender},
					{ id: 'settlement.amount', width: '250px', title: $filter('translate')('global.operationsAndInvoices.amount'), render: amountRender},
					{ id: 'actions', columnName: 'id', className: 'text-center', title: actionsTitle(), render: actionsRightAccessRender, sortable: false }
		        ];
				var tableOrderProperties = {sortName: 'id', sort: [[0,'desc']]};
		        vm.settlementTableDefinition.id = 'tableRegisterSettlement';
				vm.settlementTableDefinition.origin = 'reg';
		        vm.settlementTableDefinition.objectType = 'RegisterEntrySettlement';
				vm.settlementTableDefinition.objectIdToSelectOrigin ='reg';
				vm.settlementTableDefinition.objectIdToSelectType = 'RegisterEntrySettlement';
		        vm.settlementTableDefinition.sortName = tableOrderProperties.sortName;
		        vm.settlementTableDefinition.sort = tableOrderProperties.sort;
				vm.settlementTableDefinition.columns = columnsSettlement;
		        vm.settlementTableDefinition.containerScope = $scope;
				vm.settlementTableDefinition.useTableObjects = true;
				vm.settlementTableDefinition.callOrigin = 'reg';
				vm.settlementTableDefinition.objectIdToSelect = angular.fromJson({registerEntry:{id:vm.registerEntryId}});
				
				vm.settlementBox = {
					boxTitle: 'global.taxBlock.settlements', 
	                permissions: ((vm.isEdit)?{new:['add_dossier_settlements']}:{}),
	                tableDefinition: vm.settlementTableDefinition,
	                new: ((vm.isEdit)?{
	                		newFunc: addSettlement, 
	                		showSettlementCreateMassiveDocuments: ((vm.isEdit && (AnnexaPermissionsFactory.havePermission(['open_dossier_settlements']) || AnnexaPermissionsFactory.havePermission(['add_dossier_settlements'])))?true:false),
	                		newSettlementCreateMassiveDocuments: newSettlementCreateMassiveDocuments
	                	 }:{
	                			showSettlementCreateMassiveDocuments: ((vm.isEdit && (AnnexaPermissionsFactory.havePermission(['open_dossier_settlements']) || AnnexaPermissionsFactory.havePermission(['add_dossier_settlements'])))?true:false),
		                		newSettlementCreateMassiveDocuments: newSettlementCreateMassiveDocuments
		                 }
	                ),
					search: undefined, 
	                config: { register: {id:vm.registerEntryId} },
	                origin: 'reg',
					canShow: ((vm.isEdit && (AnnexaPermissionsFactory.havePermission(['open_dossier_settlements']) || AnnexaPermissionsFactory.havePermission(['add_dossier_settlements'])))?true:false),
	                origin: 'reg',
					alerts: [], //TODO mirar com ficar els alerts
					legend: undefined,
					closeBox: undefined, //TODO,
					numberBox: undefined, //TODO,
					settlementActive: vm.settlementsActive
				};
			}
			
			this.$onInit = function() {
				vm.settlementsActive = (($rootScope && $rootScope.app && $rootScope.app.configuration && $rootScope.app.configuration.settlement_properties_active && $rootScope.app.configuration.settlement_properties_active.active)?true:false);
				vm.languageColumn = Language.getActiveColumn();
	            vm.settlementBox = {};
        		try{
        			generateSettlementBox();	
					$scope.$on('annexaBoxRegisterSettlementReloadTable', function(event, args) {
			            if(vm.settlementTableDefinition && vm.settlementTableDefinition.reloadInternalData) {
							vm.settlementTableDefinition.reloadInternalData(true, true);	
						}
						//vm.dossierInfoComponent.dossierTabsComponent.dossierComponent.calculateCounters('dossierSettlements');
			        });
				}catch(error){
					 console.error(error);
				}
			}
        }],
        bindings: {
        	registerEntryId: '=',
        	isEdit: '='
        }
    });